import React, { useEffect, useState } from 'react';

const Hero = () => {
  const [typewriterText, setTypewriterText] = useState("Tally Prime");
  
  useEffect(() => {
    // Improved typewriter effect with React state
    const phrases = ['Tally Prime', 'DigiCloud', 'SharePro', 'Busy ERP'];

    let currentPhrase = 0;
    let currentChar = 0;
    let isDeleting = false;
    let typingSpeed = 100;

    const type = () => {
      const phrase = phrases[currentPhrase];
      
      if (isDeleting) {
        setTypewriterText(phrase.substring(0, currentChar - 1));
        currentChar--;
        typingSpeed = 50;
      } else {
        setTypewriterText(phrase.substring(0, currentChar + 1));
        currentChar++;
        typingSpeed = 150;
      }

      if (!isDeleting && currentChar === phrase.length) {
        isDeleting = true;
        typingSpeed = 1500; // Pause at end of word
      } else if (isDeleting && currentChar === 0) {
        isDeleting = false;
        currentPhrase = (currentPhrase + 1) % phrases.length;
        typingSpeed = 500; // Pause before new word
      }

      setTimeout(type, typingSpeed);
    };

    const typewriterTimeout = setTimeout(type, 1000);
    
    return () => {
      clearTimeout(typewriterTimeout);
    };
  }, []);

  return (
    <section id="hero" className="hero section dark-background">
      <img src="/assets/img/hero-bg-2.jpg" alt="" className="hero-bg" />

      <div className="container">
        <div className="row gy-4 justify-content-between">
          <div className="col-lg-4 order-lg-last hero-img" data-aos="zoom-out" data-aos-delay="100">
            <img src="/assets/img/hero-img.png" className="img-fluid animated" alt="" />
          </div>

          <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-in">
            <h1>Transforming businesses with innovative <span id="typewriter">{` ${typewriterText}`}</span></h1>
            <p>We are a team of skilled professionals delivering robust business, financial, and cloud-based solutions tailored for modern enterprises.</p>
            <div className="d-flex">
              <a href="#about" className="btn-get-started">Get Started</a>
             {/* <a href="#" className="glightbox btn-watch-video d-flex align-items-center">
                <i className="bi bi-play-circle"></i>
                <span>Watch Video</span> 
              </a> */}
            </div>
          </div>
        </div>
      </div>

      <svg className="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none">
        <defs>
          <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
        </defs>
        <g className="wave1">
          <use xlinkHref="#wave-path" x="50" y="3"></use>
        </g>
        <g className="wave2">
          <use xlinkHref="#wave-path" x="50" y="0"></use>
        </g>
        <g className="wave3">
          <use xlinkHref="#wave-path" x="50" y="9"></use>
        </g>
      </svg>
    </section>
  );
};

export default Hero; 